module.exports = __webpack_public_path__ + "static/img/PA@3x.f09485fc.jpg";